export class DeviceFwUpdateInfoListItem
{
    constructor(json: any = null)
    {
        if (json)
        {
            Object.assign(this, json);
        }
    }

    DeviceId: number;
    DisplayName: string;
    CurrentVersion: string;
    AvailableVersion: string;
}
